import { getAPIDomain } from 'utils/http';
import { safeLocalStorage } from 'utils/storage';

export const getConsentFlag = () =>
  safeLocalStorage.getItem(`${getAPIDomain()}_GDPR_consent_given`) ?? false;

export const setConsentFlag = () => {
  safeLocalStorage.setItem(`${getAPIDomain()}_GDPR_consent_given`, 'true');
};
